var map = {
	"./add.svg": 8655,
	"./arrow_forward.svg": 1662,
	"./close.svg": 4612,
	"./expand_more-dark.svg": 9097,
	"./expand_more-light.svg": 5610,
	"./facebook.svg": 8150,
	"./fingers.svg": 8822,
	"./gift-dark.svg": 1933,
	"./gift-high.svg": 1917,
	"./gift-light.svg": 6073,
	"./giving.svg": 2031,
	"./happy-dark.svg": 5002,
	"./happy-high.svg": 5494,
	"./happy-light.svg": 436,
	"./hearthands-dark.svg": 7119,
	"./hearthands-high.svg": 9340,
	"./hearthands-light.svg": 8084,
	"./instagram.svg": 6976,
	"./letter.svg": 3154,
	"./linkedin.svg": 3305,
	"./logo.svg": 9228,
	"./menu.svg": 2975,
	"./minus.svg": 6006,
	"./moviefilm-dark.svg": 8210,
	"./moviefilm-high.svg": 5604,
	"./moviefilm-light.svg": 2882,
	"./popcorn-dark.svg": 4077,
	"./popcorn-high.svg": 1144,
	"./popcorn-light.svg": 4760,
	"./question-dark.svg": 3976,
	"./question-high.svg": 727,
	"./question-light.svg": 6619,
	"./radio_button.svg": 2902,
	"./radio_button_unchecked.svg": 3578,
	"./sad-dark.svg": 4496,
	"./sad-high.svg": 4125,
	"./sad-light.svg": 4838,
	"./signup-sad.svg": 3756,
	"./signup-text.svg": 9024,
	"./threads.svg": 7834,
	"./toggle.svg": 3541,
	"./tv-dark.svg": 338,
	"./tv-high.svg": 5741,
	"./tv-light.svg": 9322,
	"./twitter.svg": 105,
	"./wave-dark.svg": 2869,
	"./wave-high.svg": 3314,
	"./wave-light.svg": 9297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6057;